// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';

export const Root = styled.div`
  background: ${({ theme }) => theme.palette.grey.A400};
  color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  min-width: 16px;
  padding: 3px 5px 2px 5px;
  margin-left: 8px;
  flex-shrink: 0;
`;
